'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  (0, _classCallCheck3.default)(this, _class);

  this.els = {
    el: el,
    select: (0, _functional.getElement)('[data-module-select]', { context: el })
  };

  Shopify.queryParams = {};

  if (location.search.length) {
    var aCouples = location.search.substr(1).split('&');
    Shopify.queryParams = aCouples.reduce(function (acc, couple) {
      var _couple$split = couple.split('='),
          _couple$split2 = (0, _slicedToArray3.default)(_couple$split, 2),
          key = _couple$split2[0],
          value = _couple$split2[1];

      if (key.length > 1) {
        acc[decodeURIComponent(key)] = decodeURIComponent(value);
      }

      return acc;
    }, {});
  }

  this.els.select.addEventListener('change', function (e) {
    Shopify.queryParams.sort_by = e.target.value;
    window.location.search = (0, _functional.serializerQueryParams)(Shopify.queryParams);
  });
};

exports.default = _class;